import script from "./VTagsInputMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./VTagsInputMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./VTagsInputMultiSelect.vue?vue&type=style&index=0&id=06c82bd9&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c82bd9"]])

export default __exports__